// extracted by mini-css-extract-plugin
module.exports = {"swiperBlock":"SwiperReviewsCard_swiperBlock__hYKU7"};